/**
 * walleu-numbered-media
 * Two optional behaviours, both loaded only when needed (see the section's
 * `wnm_needs_js` assign):
 *
 * 1. Video (tap-to-play, no native controls): clicking the frame toggles
 *    play/pause; the `is-playing` class fades the overlay button out via CSS.
 *
 * 2. Interactive mode on mobile (<1000px): the numbered list is a horizontal
 *    scroll-snap row and the swiped-to card drives the media — we check the
 *    card's radio programmatically (radio.checked never moves focus, unlike a
 *    label click, which horizontal-scrolled the whole page on mobile). Labels
 *    are pointer-events:none on mobile, so scrolling is the only interaction
 *    there; on desktop the labels stay clickable and this observer is off.
 */
(function () {
  if (window.customElements.get('walleu-numbered-media')) return;

  var MOBILE = window.matchMedia('(max-width: 999px)');

  class WalleuNumberedMedia extends HTMLElement {
    connectedCallback() {
      this._setupVideo();
      this._setupScrollSync();
    }

    disconnectedCallback() {
      this._unobserve();
      if (this._onMq) MOBILE.removeEventListener('change', this._onMq);
    }

    _setupVideo() {
      this.video = this.querySelector('video');
      this.frame = this.querySelector('[data-frame]');
      if (!this.video || !this.frame || this.video.controls) return;

      this._toggle = () => {
        if (this.video.paused || this.video.ended) {
          this.video.play().catch(() => {});
        } else {
          this.video.pause();
        }
      };
      this.frame.addEventListener('click', this._toggle);
      this.video.addEventListener('play', () => this.frame.classList.add('is-playing'));
      this.video.addEventListener('pause', () => this.frame.classList.remove('is-playing'));
    }

    _setupScrollSync() {
      if (!this.classList.contains('wnm--interactive')) return;
      this.list = this.querySelector('.wnm__list');
      if (!this.list || !this.querySelector('.wnm__radio')) return;

      this._onMq = () => (MOBILE.matches ? this._observe() : this._unobserve());
      MOBILE.addEventListener('change', this._onMq);
      this._onMq();
    }

    _observe() {
      if (this._io) return;
      this._io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            var radio = entry.target.querySelector('.wnm__radio');
            if (radio && !radio.checked) radio.checked = true;
          });
        },
        { root: this.list, threshold: 0.6 }
      );
      this.querySelectorAll('.wnm__item').forEach((item) => this._io.observe(item));
    }

    _unobserve() {
      if (!this._io) return;
      this._io.disconnect();
      this._io = null;
    }
  }

  customElements.define('walleu-numbered-media', WalleuNumberedMedia);
})();
